// 首页pc端
export const partnerList = [
  [
    {
      name: 'cisco',
      large: 1,
      url: require('../assets/partner-all/cisco.svg')
    },
    {
      name: 'huawei',
      url: require('../assets/partner-all/huawei.svg')
    },
    {
      name: 'hp',
      url: require('../assets/partner-all/hp.svg')
    },
    {
      name: 'juniper',
      url: require('../assets/partner-all/juniper.svg')
    },
    {
      name: 'netgear',
      url: require('../assets/partner-all/netgear.svg')
    },
    {
      name: 'dell',
      url: require('../assets/partner-all/dell.svg')
    },
    {
      name: 'bprocade',
      url: require('../assets/partner-all/bprocade.svg')
    },
    {
      name: 'ibm',
      large: 1,
      url: require('../assets/partner-all/ibm.svg')
    }
  ],
  [
    {
      name: 'lenovo',
      url: require('../assets/partner-all/lenovo.svg')
    },
    {
      name: 'linux',
      url: require('../assets/partner-all/linux.png')
    },
    {
      name: 'redhat',
      url: require('../assets/partner-all/redhat.svg')
    },
    {
      name: 'mysql',
      large: 1,
      url: require('../assets/partner-all/mysql.svg')
    },
    {
      name: 'oracle',
      url: require('../assets/partner-all/oracle.svg')
    },
    {
      name: 'microsoft-sql-server',
      url: require('../assets/partner-all/microsoft-sql-server.png')
    },
    {
      name: 'postgresql',
      large: 1,
      url: require('../assets/partner-all/postgresql.svg')
    },
    {
      name: 'mongodb',
      url: require('../assets/partner-all/mongodb.svg')
    }
  ],
  [
    {
      name: 'citrix',
      url: require('../assets/partner-all/citrix.png')
    },
    {
      name: 'vmware',
      url: require('../assets/partner-all/vmware.svg')
    },
    {
      name: 'kubernetes',
      url: require('../assets/partner-all/kubernetes.svg')
    },
    {
      name: 'netapp',
      url: require('../assets/partner-all/netapp.png')
    },
    {
      name: 'openstack',
      url: require('../assets/partner-all/openstack.svg')
    },
    {
      name: 'redis',
      url: require('../assets/partner-all/redis.svg')
    },
    {
      name: 'docker',
      large: 1,
      url: require('../assets/partner-all/docker.svg')
    }
  ]
]

// 首页，合作伙伴页移动端
export const mobilePartnerList = [
  [
    {
      name: 'cisco',
      url: require('../assets/partner-all/cisco.svg')
    },
    {
      name: 'huawei',
      url: require('../assets/partner-all/huawei.svg')
    },
    {
      name: 'hp',
      url: require('../assets/partner-all/hp.svg')
    },
    {
      name: 'juniper',
      url: require('../assets/partner-all/juniper.svg')
    },
    {
      name: 'netgear',
      url: require('../assets/partner-all/netgear.svg')
    },
    {
      name: 'dell',
      url: require('../assets/partner-all/dell.svg')
    }
  ],
  [
    {
      name: 'bprocade',
      url: require('../assets/partner-all/bprocade.svg')
    },
    {
      name: 'ibm',
      url: require('../assets/partner-all/ibm.svg')
    },
    {
      name: 'lenovo',
      url: require('../assets/partner-all/lenovo.svg')
    },
    {
      name: 'linux',
      url: require('../assets/partner-all/linux.png')
    },
    {
      name: 'redhat',
      url: require('../assets/partner-all/redhat.svg')
    },
    {
      name: 'mysql',
      url: require('../assets/partner-all/mysql.svg')
    }
  ],
  [
    {
      name: 'oracle',
      url: require('../assets/partner-all/oracle.svg')
    },
    {
      name: 'microsoft-sql-server',
      url: require('../assets/partner-all/microsoft-sql-server.png')
    },
    {
      name: 'postgresql',
      url: require('../assets/partner-all/postgresql.svg')
    },
    {
      name: 'mongodb',
      url: require('../assets/partner-all/mongodb.svg')
    },
    {
      name: 'citrix',
      url: require('../assets/partner-all/citrix.png')
    },
    {
      name: 'vmware',
      url: require('../assets/partner-all/vmware.svg')
    }
  ],
  [
    {
      name: 'kubernetes',
      url: require('../assets/partner-all/kubernetes.svg')
    },
    {
      name: 'netapp',
      url: require('../assets/partner-all/netapp.png')
    },
    {
      name: 'openstack',
      url: require('../assets/partner-all/openstack.svg')
    },
    {
      name: 'redis',
      url: require('../assets/partner-all/redis.svg')
    },
    {
      name: 'docker',
      url: require('../assets/partner-all/docker.svg')
    }
  ]
]

// 合作伙伴页pc端
export const allPartnerList = [

  {
    name: 'cisco',
    url: require('../assets/partner-all/cisco.svg')
  },
  {
    name: 'huawei',
    url: require('../assets/partner-all/huawei.svg')
  },
  {
    name: 'hp',
    url: require('../assets/partner-all/hp.svg')
  },
  {
    name: 'juniper',
    url: require('../assets/partner-all/juniper.svg')
  },
  {
    name: 'netgear',
    url: require('../assets/partner-all/netgear.svg')
  },
  {
    name: 'dell',
    url: require('../assets/partner-all/dell.svg')
  },
  {
    name: 'bprocade',
    url: require('../assets/partner-all/bprocade.svg')
  },
  {
    name: 'ibm',
    url: require('../assets/partner-all/ibm.svg')
  },
  {
    name: 'lenovo',
    url: require('../assets/partner-all/lenovo.svg')
  },
  {
    name: 'linux',
    url: require('../assets/partner-all/linux.png')
  },
  {
    name: 'redhat',
    url: require('../assets/partner-all/redhat.svg')
  },
  {
    name: 'mysql',
    url: require('../assets/partner-all/mysql.svg')
  },
  {
    name: 'oracle',
    url: require('../assets/partner-all/oracle.svg')
  },
  {
    name: 'microsoft-sql-server',
    url: require('../assets/partner-all/microsoft-sql-server.png')
  },
  {
    name: 'postgresql',
    url: require('../assets/partner-all/postgresql.svg')
  },
  {
    name: 'mongodb',
    url: require('../assets/partner-all/mongodb.svg')
  },
  {
    name: 'citrix',
    url: require('../assets/partner-all/citrix.png')
  },
  {
    name: 'vmware',
    url: require('../assets/partner-all/vmware.svg')
  },
  {
    name: 'kubernetes',
    url: require('../assets/partner-all/kubernetes.svg')
  },
  {
    name: 'netapp',
    url: require('../assets/partner-all/netapp.png')
  },
  {
    name: 'openstack',
    url: require('../assets/partner-all/openstack.svg')
  },
  {
    name: 'redis',
    url: require('../assets/partner-all/redis.svg')
  },
  {
    name: 'docker',
    url: require('../assets/partner-all/docker.svg')
  }
]
